// extracted by mini-css-extract-plugin
module.exports = {"itemInfoBoxJtails":"InfoBox-Jtails_itemInfoBoxJtails_3fxhv","isStyleDingBeauty":"InfoBox-Jtails_isStyleDingBeauty_3sm8d"};